<template>
    <div id="callbackTaskOngoing">
        <Headers :headersText='headersText'></Headers>

        <div class="taskPanel">
            <div class="panel">
                <div class="lefts">
                    <img :src="callbackDetails.icon?callbackDetails.icon:'../assets/images/img_77.png'" alt="">
                    <div class="text">
                        <span>完成任务</span>
                        <span>立赚{{callbackDetails.price}}元</span>
                    </div>
                </div>
                <!-- <div class="rights">限时{{surplusTimes}}</div> -->
            </div>

            <!-- 步骤面板 -->
            <div class="boxPadding">
                <div class="stepPanel">
                    <div class="step">
                        <div class="tit">
                            <div class="sign">STEP1</div>
                            <span>搜索关键词：{{callbackDetails.keyword}}</span>
                        </div>
                        <div class="seat">
                            <div class="centers">
                                <img :src="callbackDetails.icon?callbackDetails.icon:'../assets/images/img_77.png'" alt="">
                                <div>排名约<span>{{callbackDetails.ranking}}</span>位 找到它并下载</div>
                            </div>
                            <div class="oneBtn" :data-clipboard-text="callbackDetails.keyword" @click="toAppstore">复制关键词前往appstore</div>
                        </div>
                    </div>
                    <div class="step">
                        <div class="tit">
                            <div class="sign">STEP2</div>
                            <span>返回本页打开应用 试玩3分钟</span>
                        </div>
                        <div class="seat">
                            <div class="centers">
                                <div>试玩时必须允许 【无限局限网与蜂窝移动网络】</div>
                            </div>
                            <div @click="openApp" class="twoBtn">打开APP</div>
                        </div>
                        
                    </div>
                    <div class="step">
                        <div class="tit">
                            <div class="sign">STEP3</div>
                            <span>试玩结束 领取奖励</span>
                        </div>
                        <div class="seat">
                            <div class="centers">
                                <!-- <div>试玩时间倒计时2:59</div> -->
                                <div>完成步骤一和步骤二后，奖励会自动下发至账户</div>
                            </div>
                            <!-- <div class="threeBtn">领取奖励</div> -->
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import Clipboard from 'clipboard'
    import Headers from '../components/headersL'

    // 引入助手客户端api
    import clientApi from '../assets/js/clientApi';
    import { Dialog } from 'vant';
    
    export default {
        components:{
            Headers,
        },
        data() {
            return {
                headersText:'回调任务进行中',

                callbackDetails:{},  // 详情数据

                surplusTimes:'', // 剩余时间
                timer:null, // 计时器
            }
        },
        created() {
            this.changeInit();
            document.addEventListener("visibilitychange", (e) => {
                if(!e.path[0].hidden){ 
                    clearInterval(this.timer);
                    this.surplusTimes = '';
                    this.changeInit();
                } 
            }, false);
        },
        methods: {
            // 封装执行函数
            changeInit(){
                if(this.$route.query.ids){
                    this.init();
                } else {
                    // this.$toast('请返回快速任务页重新进入该页面')
                }
            },
            // 初始化请求
            init(){
                this.$loading(true);
                // console.log(this.$route.query.ids);
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('callback_task/detail',datas,(res)=>{
                    console.log(res.data);

                    this.callbackDetails = res.data;
                    this.countDownFun(res.data.task_endtime);
                    this.$loading(false);
                });
            },
            // 封装倒计时
            countDownFun(taskEndTime){
                if(taskEndTime <= 0){
                    this.surplusTimes = '00:00'
                    clearInterval(this.timer)
                } else {
                    this.timeFormat(taskEndTime);
                    this.timer = setInterval(()=>{
                        taskEndTime--;

                        if(taskEndTime <= 0){
                            this.surplusTimes = '00:00'
                            clearInterval(this.timer)
                        } else {
                            this.timeFormat(taskEndTime);
                        }
                        
                    },1000)
                }
            },
            timeFormat(taskEndTime){
                let endTimeMinute = Math.floor(taskEndTime/60%60);
                let endTimeSecond = Math.floor(taskEndTime%60);
                endTimeMinute = endTimeMinute>=10?endTimeMinute:'0'+endTimeMinute;
                endTimeSecond = endTimeSecond>=10?endTimeSecond:'0'+endTimeSecond;
                this.surplusTimes = endTimeMinute+':'+endTimeSecond;
            },
            // 去App Store下载
            toAppstore(){
                console.log(this.callbackDetails.iskeywords)
                // 去App Store前检测回调任务
                this.checkCallBackTask().then((res) => {
                    if(this.callbackDetails.iskeywords == 1){
                        // 没有关键词
                        window.location.href = this.callbackDetails.url
                    } else if(this.callbackDetails.iskeywords == 2) {
                        // 有关键词
                        var clipboard = new Clipboard('.oneBtn')
                        clipboard.on('success', e => {
                            this.$toast('复制关键词成功')
                            setTimeout(()=>{
                                window.location.href = 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/search?mt=8&submit=edit&term='+''+'#software'
                            },1500)
                            // 释放内存
                            clipboard.destroy()
                        })
                        clipboard.on('error', e => {
                            // 不支持复制
                            this.$toast('该浏览器不支持自动复制，请长按进行复制')
                            // 释放内存
                            clipboard.destroy()
                        })
                    } 
                });      
            },
            // 打开App
            openApp() {
                if(this.callbackDetails.is_ios11 === true) {
                    this.checkInstallForiOS11();
                }else {
                    this.checkInstallForiOS10();
                }
            },
            // iOS 10及以下检测是否安装应用并打开
            checkInstallForiOS10() {
                let params = '?bundleid=' + encodeURIComponent(this.callbackDetails.boundid);
                clientApi.isAppExistForiOS10(params).then((response)=> {
                    if (response.status == 1) {
                        //1直接打开应用，2推送本地消息
                        clientApi.ios11openurl(data).then((response)=> {
                            let pushData={title:"温馨提示：您的任务正在进行中，打开时请允许App网络访问哟"};
                            clientApi.localpush(pushData);
                        }).catch( (err)=> {
                            Dialog.alert({message: '网络错误'});
                        });
                    }else {
                        Dialog.alert({message: 'APP未安装，快去APP store下载吧'});
                    }
                }).catch( (err)=>{
                    Dialog.alert({message: '网络错误'});
                });
            },
            // iOS 11及以上检测是否安装应用并打开
            checkInstallForiOS11() {
                let data={bundleid: encodeURIComponent(this.callbackDetails.boundid)};
                clientApi.ios11openurl(data).then((response)=> {
                    if(response.data==1){
                        let pushData={title:"温馨提示：您的任务正在进行中，打开时请允许App网络访问哟"};
                        clientApi.localpush(pushData);
                    }else {
                        Dialog.alert({message: 'APP未安装，快去APP store下载吧'});
                    }
                }).catch( (err)=> {
                    Dialog.alert({message: '网络错误'});
                });
            },
            // 检测回调任务
            checkCallBackTask() {
                return new Promise((resolve, reject) => {
                    // 调用后端api
                    let datas = {
                        task_id: this.callbackDetails.id
                    }
                    this.$http.POSTS('callback_task/openApp', datas, (res) => {
                        resolve();
                    });
                });
            }
        },
    }
</script>

<style lang="less" scoped>
    #callbackTaskOngoing{
        .taskPanel{
            width: 375px;
            height: 50px;
            padding-top: 8px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .panel{
                width:318px;
                height:83px;
                background:rgba(255,255,255,1);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                margin: 0 15px;
                padding: 0 18px 0 9px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .lefts{
                    display: flex;
                    img{
                        width: 44px;
                        height: 44px;
                        margin-right: 13px;
                        border-radius: 12px;
                    }
                    .text{
                        height: 44px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        span{
                            &:nth-of-type(1){
                                font-size:14px;
                                font-weight:600;
                                color:rgba(68,68,68,1);
                                line-height:20px;
                            }
                            &:nth-of-type(2){
                                font-size:11px;
                                font-weight:500;
                                color:rgba(144,144,144,1);
                                line-height:16px;
                            }
                        }
                    }
                }
                .rights{
                    font-size:16px;
                    font-weight:bold;
                    color:rgba(234,53,63,1);
                    line-height:22px;
                }
            }

            // 步骤面板
            .boxPadding{
                padding: 15px;
                .stepPanel{
                    width:325px;
                    background:rgba(255,255,255,1);
                    border-radius:5px;
                    border:1px solid rgba(216,216,216,1);
                    padding: 10px;
                    .step{
                        .tit{
                            display: flex;
                            align-items: center;
                            .sign{
                                width:50px;
                                height:19px;
                                background:rgba(249,249,249,1);
                                border-radius:5px;
                                border:1px solid rgba(222,222,222,1);
                                font-size:14px;
                                font-weight:400;
                                color:rgba(102,102,102,1);
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            }
                            span{
                                font-size:16px;
                                font-weight:600;
                                color:rgba(51,51,51,1);
                                line-height:22px;
                                margin-left: 14px;
                            }
                        }
                        .seat{
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            .centers{
                                display: flex;
                                align-items: center;
                                margin: 10px 0 16px;
                                img{
                                    width: 44px;
                                    height: 44px;
                                    margin-right: 11px;
                                    border-radius: 12px;
                                }
                                &>div{
                                    font-size:12px;
                                    font-weight:400;
                                    color:rgba(51,51,51,1);
                                    line-height:17px;
                                    span{
                                        font-size:14px;
                                        color:rgba(233,44,55,1);
                                        line-height:20px;
                                    }
                                }
                            }
                            .oneBtn{
                                width:200px;
                                height:34px;
                                background:rgba(233,44,55,1);
                                border-radius:17px;
                                box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                                font-size:14px;
                                font-weight:400;
                                color:rgba(255,255,255,1);
                                line-height:34px;
                                text-align: center; 
                                margin-bottom: 16px;                       
                            }
                            .twoBtn,.threeBtn{
                                width:128px;
                                height:34px;
                                background:rgba(233,44,55,1);
                                border-radius:17px;
                                box-shadow:0px 5px 10px 0px rgba(229,1,19,0.2);
                                font-size:14px;
                                font-weight:400;
                                color:rgba(255,255,255,1);
                                line-height:34px;
                                text-align: center;
                                margin-bottom: 16px;
                            }
                        }
                    }
                }
            }
            
        }
    }
</style>